<template>
    <div class="vx-row mb-2">
        <div class="vx-col w-full mt-5">
            <h5>Площадки</h5>
        </div>

        <div class="vx-col w-full">
            <div class="mt-1">
                <template>
                    <div v-for="(item, index) in items" :key="index" class="row">
                        <template>
                            <div class="vx-row">
                                <div class="vx-col w-1/3">
                                    <label class="vs-input--label required"> Площадка </label>
                                    <v-select
                                        :options="dicts.platforms"
                                        label="name"
                                        placeholder="Выберите площадку"
                                        class="w-full"
                                        v-model="item.platformId"
                                        :reduce="a => a.id"
                                        :clearable="false"
                                    ></v-select>
                                </div>
                            
                                <div class="vx-col w-1/3">
                                    <div class="mt-1">
                                        <label class="vs-input--label">
                                            Является ли организация владельцем платформы
                                        </label>
                                        <vs-checkbox 
                                            class="mt-3" 
                                            icon="check" 
                                            color="rgb(38, 187, 174)"
                                            v-model="item.isPlatformOwner">
                                        </vs-checkbox>
                                    </div>
                                </div>

                                <div class="float-right">
                                    <vs-button round @click="remove(index)" icon="delete" color="danger" />
                                        <vs-button
                                            round
                                            v-if="index + 1 === items.length"
                                            @click="add"
                                            icon="control_point"
                                            color="success"
                                            class="add-row"
                                        />
                                </div>
                            </div>
                        </template>
                    </div>
                </template>
            </div>
        </div>

        <div :v-if="error" class="vx-col w-full text-danger">
            {{ error }}
        </div>
    </div> 
</template>


<script>
import vSelect from 'vue-select';
import axios from 'axios';

export default {
    name: 'platforms-block',
    props: {
        items: {},
        error: ''
    },
    data() {

        return {
            itemRemoval: true,
            form: {
            },
            dicts: {
                platforms: []
            },
            errors: {
            }
        };
    },
    components: {
        'v-select': vSelect
    },
    methods: {
        loadDicts() {
            this.axios
                .all([this.axios.get('organizations/platforms/dictionaries')])
                .then(
                    axios.spread((dicts) => {
                        this.dicts.platforms = dicts.data.platforms;
                    })
                )
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки справочников.',
                        color: 'danger'
                    });
                });
        },
        remove(platformId) {
            if (!this.itemRemoval) {
                this.items.splice(platformId, 1);
                this.select();
            } else {
                this.items = [];
                this.add();
            }
        },
        add() {
            if (!this.validate()) {
                return;
            }

            this.items.push({
                platformId: null,
                isPlatformOwner: false
            });

            this.select();
        },
        validate() {
            let checkPlatforms = this.items.filter((item) => !item.platformId);
            if (checkPlatforms.length >= 1 && this.items.length > 0) {
                this.$vs.notify({
                    title: 'Внимание!',
                    text: 'Выберите площадку.',
                    color: 'warning'
                });
                return false;
            }
            return true;
        },
        select() {
            this.$emit("selectPlatforms", this.items);
        }
    },
    mounted() {
        this.loadDicts();
    },
    watch: {
        items() {
            this.itemRemoval = this.items.length <= 1;
        }
    }
};
</script>

<style scoped>

</style>